/**
 * Сколько учеников на марафоне — по тому же ответу, из которого нарисован список.
 *
 * ⚠️ НЕ ИЗ КАРТОЧКИ МАРАФОНА. `GET /admin/marathons/:id` отдаёт `student_count`,
 * но `GetFullMarathon` его не заполняет — у любого курса там 0 (10.09.2026: в шапке
 * «0», в списке 23). Список записей — `GET /admin/enrollments?marathon_id=…`; он
 * приходит целиком, без страниц (`ListByMarathon` без LIMIT, `total = len(items)`).
 *
 * ⚠️ «УЧЕНИКИ» — ТОЛЬКО С ДЕЙСТВУЮЩИМ ДОСТУПОМ (техдолг 416, решение владельца 16.10.2026). Прежде шапка брала
 * `total` — все записи любого статуса, а список курсов (`StudentCountsByMarathon` в courses) считает разных учеников
 * со `status = 'active'`: у TEST-PREV на стенде вышло 9 против 7. Теперь число то же, что в списке, а истёкшие —
 * отдельно («7 учеников · 2 истёкших»). Снятые (`inactive`) и старые `cancelled`/`pending` в шапку не идут: они
 * видны во вкладке «Ученики» с меткой статуса.
 *
 * `null` — ответ ещё не пришёл: ноль в шапке означал бы «учеников нет».
 */
export type MarathonStudentCounts = { active: number; expired: number };

export function marathonStudentCounts(
  enrollments: { items?: readonly { student_id?: string; status?: string }[] } | undefined,
): MarathonStudentCounts | null {
  if (!enrollments) return null;
  const active = new Set<string>();
  const expired = new Set<string>();
  (enrollments.items ?? []).forEach((e, i) => {
    // Без student_id строка всё равно ученик — считаем её саму, а не теряем.
    const who = e.student_id || `#${i}`;
    if (e.status === 'active') active.add(who);
    else if (e.status === 'expired') expired.add(who);
  });
  // Истёкшая запись того, у кого есть и действующая, — не «истёкший ученик».
  active.forEach((who) => expired.delete(who));
  return { active: active.size, expired: expired.size };
}
